var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 18C0 8.05781 8.05781 0 18 0C27.9422 0 36 8.05781 36 18C36 27.9422 27.9422 36 18 36C8.05781 36 0 27.9422 0 18ZM18 25.875C18.9352 25.875 19.6875 25.1227 19.6875 24.1875V19.6875H24.1875C25.1227 19.6875 25.875 18.9352 25.875 18C25.875 17.0648 25.1227 16.3125 24.1875 16.3125H19.6875V11.8125C19.6875 10.8773 18.9352 10.125 18 10.125C17.0648 10.125 16.3125 10.8773 16.3125 11.8125V16.3125H11.8125C10.8773 16.3125 10.125 17.0648 10.125 18C10.125 18.9352 10.8773 19.6875 11.8125 19.6875H16.3125V24.1875C16.3125 25.1227 17.0648 25.875 18 25.875Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusCircle);
export default __webpack_public_path__ + "static/media/plus_circle.10b3ced25f98c18ee9eb2b653185e502.svg";
export { ForwardRef as ReactComponent };